import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/regular/check.svg'
import BaseIcon from '../../BaseIcon'

const Check = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 448 512" />
}

Check.propTypes = {
	className: PropTypes.string,
}

export default Check
